/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './Documents.scss';
import { formatNumber } from 'utils'
import { loadDocuments } from 'actions/building'
import {domain} from "constants/Config";
import { withTranslation } from 'react-i18next';
const icons = {
  pdf: require('assets/images/icons/icon-pdf.svg'),
  doc: require('assets/images/icons/icon-doc.svg'),
  docx: require('assets/images/icons/icon-doc.svg'),
  xls: require('assets/images/icons/icon-xls.svg'),
  xlsx: require('assets/images/icons/icon-xls.svg'),
  txt: require('assets/images/icons/icon-txt.svg'),
  png: require('assets/images/icons/icon-png.svg'),
  jpg: require('assets/images/icons/icon-jpg.svg'),
  jpeg: require('assets/images/icons/icon-jpg.svg'),
}

const extention = /\.([0-9a-z]+)$/i;

class Documents extends Component {

  componentDidMount() {
    this.props.loadDocuments(this.props.params.id)
  }

  render() {
    const { className, building, isDocumentsLoading, client, t } = this.props;
    const {documents} = building;

    return (
      <div className={cn(styles.Documents, className)}>
        {(documents && documents.length > 0) ? (
            <div>
              <h3 className={client ? styles.TitleClient : styles.Title}>
                {t('components.building.main.documents.title')}
              </h3>
              <div className={styles.DocumentsList}>
                {
                  documents &&
                  documents.map(
                    ({id, path, name}) => (
                      <a
                        className={styles.Document}
                        target="_blank"
                        href={`https://phoenix.${domain}.ru/${path}`}
                        key={id}
                      >
                        <span className={styles.DocumentIcon}>
                          <img
                            src={icons[path.toLowerCase().match(extention)[1]]}
                            alt=""
                          />
                        </span>
                        {name}
                      </a>
                    )
                  )
                }
              </div>
            </div>
        ) : ''}
      </div>
    );
  }
}

export default withTranslation()(connect(null, { loadDocuments })(Documents));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Documents/Documents.js